"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSplMemoProgramId = exports.getSplMemoProgram = exports.createSplMemoProgram = exports.SPL_MEMO_PROGRAM_ID = void 0;
const errors_1 = require("../errors");
exports.SPL_MEMO_PROGRAM_ID = 'Memo1UhkJRfHyvLMcVucJwxXeuD728EqVDDwQDxFMNo';
function createSplMemoProgram() {
    return {
        name: 'splMemo',
        publicKey: exports.SPL_MEMO_PROGRAM_ID,
        getErrorFromCode(code, cause) {
            return (0, errors_1.getSplMemoErrorFromCode)(code, this, cause);
        },
        getErrorFromName(name, cause) {
            return (0, errors_1.getSplMemoErrorFromName)(name, this, cause);
        },
        isOnCluster() {
            return true;
        },
    };
}
exports.createSplMemoProgram = createSplMemoProgram;
function getSplMemoProgram(context, clusterFilter) {
    return context.programs.get('splMemo', clusterFilter);
}
exports.getSplMemoProgram = getSplMemoProgram;
function getSplMemoProgramId(context, clusterFilter) {
    return context.programs.getPublicKey('splMemo', exports.SPL_MEMO_PROGRAM_ID, clusterFilter);
}
exports.getSplMemoProgramId = getSplMemoProgramId;
//# sourceMappingURL=splMemo.js.map